import { render, staticRenderFns } from "./searchPopup.vue?vue&type=template&id=3994f500&scoped=true&"
import script from "./searchPopup.vue?vue&type=script&lang=js&"
export * from "./searchPopup.vue?vue&type=script&lang=js&"
import style0 from "./searchPopup.vue?vue&type=style&index=0&id=3994f500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994f500",
  null
  
)

export default component.exports